import React, { useState } from 'react';
import HomeLayout from 'layouts/HomeLayout';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  allPortfoiloEvents,
  coperativeData,
  privateBirthdayData,
  entertainmentData,
  allPortfolioCardData,
  privateCardData,
  corporativeCardData,
  entertainmentCardData,
} from 'helpers/portfolioHelper';

const OurPortfolio = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'DE EVENTE PORTFOLIO',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('all');

  let [tabList] = useState([
    {
      id: 1,
      name: 'all',
      active: true,
      component: (
        <TabsListing
          list={allPortfoiloEvents}
          url=''
          cardData={allPortfolioCardData}
        />
      ),
    },
    {
      id: 2,
      name: 'corporative',
      component: (
        <TabsListing
          list={coperativeData}
          url='/portfolio/corporative'
          cardData={corporativeCardData}
        />
      ),
    },
    {
      id: 3,
      name: 'entertainment',
      component: (
        <TabsListing
          list={entertainmentData}
          url='/portfolio/entertainment'
          cardData={entertainmentCardData}
        />
      ),
    },
    {
      id: 4,
      name: 'private',
      component: (
        <TabsListing
          list={privateBirthdayData}
          url='/portfolio/private'
          cardData={privateCardData}
        />
      ),
    },
    {
      id: 5,
      name: 'customize',
      component: 'No Data Available',
    },
  ]);
  return (
    <>
      <section className='portfolioPage DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
        <div className='max-w-7xl mx-auto'>
          <div>
            <TitleSection titleDetail={titleDetail} />
            <CommonTab
              tabList={tabList}
              setCurrentTab={setCurrentTab}
              currentTab={currentTab}
              maxWidth='max-w-2xl'
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default HomeLayout(OurPortfolio);
